import React,{useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import {Typography } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .Mui-selected': {
        fontWeight:"bold"
      },
    },
  },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
  root: props =>({
      marginTop:props.margin?props.margin:"3rem",
      width:props.margin? '100%':'320px',
      height:"52px",
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding:'1rem 1rem',
      marginBottom:props.margin?'2rem':"0"
      
  }),
  btnText:{
    fontWeight:"400",
    color:"rgba(0, 0, 0,0.87)",
    fontSize:"16px"
  },
  btnIcon:{
    fontSize:"21px",
    color:"rgba(0, 0, 0,0.54)",
  },
  paper: {
    '& .MuiPaper-root': {
      backgroundColor: 'white',
       msOverflowStyle:"none",
      scrollbarWidth:"none",
    },
    '& .MuiMenu-list':{
      minHeight:"auto",
      maxHeight:'200px',
      padding:"0rem"
    },
    '& ::-webkit-scrollbar': {
      display: "none",  
    },  
  },
  item: {
    '& :focus': {
      backgroundColor:theme.palette.primary.main,
      fontWeight:"bold"
    }
  }

}));

const RlTimepicker = ({timeList,setSelectTime,margin}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(timeList.findIndex((time)=>time.isOpen));
  const classes = useStyles({margin});
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
   
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e,index) => {
    if(typeof index === "number"){
      setSelectedIndex(index);
      setSelectTime(timeList[index])
     
    }
    setAnchorEl(null);
  };
  useEffect(()=>{
    setSelectTime(typeof selectedIndex === 'number'?timeList[selectedIndex]:timeList[0])
  },[])
  return (
    <div>
      <Button 
        className={classes.root} 
        onClick={handleClick} 
        variant="outlined" 
        aria-controls="customized-menu"
        aria-haspopup="true">
       <Typography 
         variant="p"
         className={classes.btnText}
       >
         {timeList && selectedIndex && timeList.length && typeof selectedIndex === 'number'?timeList[selectedIndex].time:timeList[0].time}
       </Typography>

       <AccessTimeIcon className={classes.btnIcon} />
      </Button>
     
      <StyledMenu
        className={classes.paper}
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
     
        {timeList && timeList.length !== 0 && timeList.map((time,index)=>{
          return(
            <StyledMenuItem key={time.time}  
            onClick={(e)=>handleClose(e,index)}  
            selected={index === selectedIndex}
            disabled={!time.isOpen}
            >
            {time.time}
            </StyledMenuItem >
          )
          
        })}

     
      </StyledMenu>
    </div>
  );
};

export default RlTimepicker;
